import { apiClient } from "@api/client";
import { request } from "@api/request";
import type { components, operations } from "@api/schema";

export type EntityKind = components["schemas"]["EntitySearchResult"]["kind"];

export type SearchKind = NonNullable<
  NonNullable<
    operations["search_entities_search_get"]["parameters"]["query"]
  >["kind"]
>[number];

export interface Entity {
  id: string;
  name: string;
  kind: EntityKind;
  createdAt?: string;
  /** Only for kind "patient": its primary household member. */
  clientName?: string;
  /** Set for kinds "patient" and "client". */
  householdId?: string;
}

export const kindLabel = (entity: Entity) => entity.kind.replace(/_/g, " ");

const toEntity = (e: components["schemas"]["EntitySearchResult"]): Entity => ({
  id: e.entity_uuid,
  name: e.name,
  kind: e.kind,
  createdAt: e.created_at,
  clientName: e.client_name ?? undefined,
  householdId: e.household_uuid ?? undefined,
});

export const entitiesClient = {
  search: (q: string, kinds: readonly SearchKind[]): Promise<Entity[]> =>
    request(() =>
      apiClient.GET("/entities/search", {
        params: { query: { q: q || undefined, kind: [...kinds] } },
      }),
    ).then((rows) => rows.map(toEntity)),
};
